import angular from 'angular';
import RwPriorPeriodYearComponent from './rw-prior-period-year-component';

export default angular.module('rw-prior-period-year', []).component('rwPriorPeriodYear', new RwPriorPeriodYearComponent());



// WEBPACK FOOTER //
// ./src/modules/utils/rw-prior-period-year/rw-prior-period-year-module.js